import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import MultipleChoiceQuestion from './MultipleChoiceQuestion';
import { Loading } from '../Loading/Loading';
import { Button } from 'react-bootstrap';
import { HORIZONTAL, VERTICAL } from '../../constants/common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowSquareDown,
  faArrowSquareRight,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';

import './Quiz.sass';

export default class Worksheet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasSentCompletedRequest: false,
    };

    this.showResultsButtonRef = React.createRef();
  }

  getStudentAnswer(questionId) {
    return this.props.responses.find((item) => item.questionId === questionId);
  }

  getNumCompleted() {
    return this.props.responses.filter((response) => response.isAnswered)
      .length;
  }

  isAllAnswered() {
    return (
      this.props.questions.length > 0 &&
      this.getNumCompleted() === this.props.questions.length
    );
  }

  handleAnswerCorrect = () => {
    // For worksheets, if all questions are answered, focus Show Results button
    setTimeout(() => {
      if (this.isAllAnswered() && this.showResultsButtonRef.current) {
        this.showResultsButtonRef.current.focus();
      }
    }, 100);
  };

  /**
   * @deprecated - The old react UI requires the user to click "Show Results" to
   * trigger this action.  Once the old UI has been replaced, the backend can be
   * modified to automatically mark an exercise as finished once all questions
   * have been answered.  Then we can just use the WorksheetWrap's showResults
   * state to prevent jumping to results as soon as the last question is answered.
   * This function, the component lifecycle methods, and the state, should all be
   * able to be removed.  Review with caution in case other logic has been added.
   */
  autoMarkComplete() {
    if (typeof this.props.score === 'undefined' && this.isAllAnswered()) {
      this.setState({
        hasSentCompletedRequest: true,
      });
      this.props.finishExercise(this.props.code);
    }
  }

  componentDidUpdate() {
    if (!this.state.hasSentCompletedRequest) {
      this.autoMarkComplete();
    }
  }

  componentDidMount() {
    if (!this.state.hasSentCompletedRequest) {
      this.autoMarkComplete();
    }
  }

  render() {
    if (!this.props.questions.length) {
      return <Loading message="Loading worksheet..." />;
    }

    const numCompleted = this.getNumCompleted();
    return (
      <div className="activity-container">
        <div className="activity-title">
          <div>{this.props.name}</div>
          <div className="btn-group btn-group-xs">
            <button
              className="btn btn-default"
              title="Dock to Side"
              onClick={() => this.props.setOrientation(VERTICAL)}
              disabled={this.props.orientation === VERTICAL}
            >
              <FontAwesomeIcon icon={faArrowSquareRight} />
            </button>
            <button
              className="btn btn-default"
              title="Dock to Bottom"
              onClick={() => this.props.setOrientation(HORIZONTAL)}
              disabled={this.props.orientation === HORIZONTAL}
            >
              <FontAwesomeIcon icon={faArrowSquareDown} />
            </button>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between p-2 border-bottom bg-white">
          <div className="fst-italic">
            Completed {numCompleted} of {this.props.questions.length}
          </div>
          {this.isAllAnswered() && (
            <Button
              variant="primary"
              size="sm"
              onClick={() => this.props.showResults()}
              ref={this.showResultsButtonRef}
            >
              Show Results
            </Button>
          )}
        </div>

        <div className="box box-scroll">
          <ol className="worksheet">
            {this.props.questions.map((question) => {
              const response = this.getStudentAnswer(question.id);
              return (
                <li key={question.id}>
                  <div className="p-2 pt-0 d-flex flex-column justify-content-between bg-white me-3 rounded">
                    <MultipleChoiceQuestion
                      {...question}
                      ref={'question' + question.id}
                      quizId={this.props.code}
                      chooseAnswer={this.props.chooseAnswer}
                      onAnswerCorrect={this.handleAnswerCorrect}
                      checking={response && response.checking === true}
                      response={response}
                    />
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    );
  }
}

Worksheet.propTypes = {
  code: PropTypes.string.isRequired,
  name: PropTypes.string,
  questions: PropTypes.array,
  responses: PropTypes.array,
  score: PropTypes.number,
  chooseAnswer: PropTypes.func.isRequired,
  showResults: PropTypes.func.isRequired,
  finishExercise: PropTypes.func.isRequired,
};

Worksheet.defaultProps = {
  code: '',
  name: '',
  questions: [],
  responses: [],
  score: undefined,
};
